import OAddResource from './o-add-resource.vue'

export default OAddResource
